/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreatePlanRequestDTO { 
    /**
     * Measured client identifier. Use the client ID returned by the authenticated context.
     */
    clientId: number;
    /**
     * Brand identifier within the client. Use this together with clientId when a request targets a specific brand.
     */
    brandId: number;
    /**
     * Title for the new MPO plan. This is the label the plan list will show.
     */
    planName: string;
    /**
     * Conversion type ID for the new plan. Use a valid conversion type from the layout endpoint.
     */
    conversionTypeId: number;
    /**
     * Optimization view for the new plan.
     */
    viewType: CreatePlanRequestDTO.ViewTypeEnum;
}
export namespace CreatePlanRequestDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
}


